import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ErrorNotification } from "../components/notification/ErrorNotification.tsx";
import { SuccessNotification } from "../components/notification/SuccessNotification.tsx";
import { Template } from "../models/Template.ts";
import { ReactQueryKeys } from "../services/ReactQueryKeys.ts";
import { useTemplateService } from "../services/useTemplateService.ts";

export function useTemplateMutation() {
  const { updateTemplate } = useTemplateService();
  const queryClient = useQueryClient();
  const updateTemplateMutation = useMutation({
    mutationFn: ({ template }: { template: Template; source: string }) => {
      return updateTemplate(template);
    },
    onError: (_, { source }) => {
      const message =
        source === "onSubmit"
          ? "A problem occurred while updating the template."
          : "A problem occurred while coming back to default.";
      ErrorNotification(message);
    },
    onSuccess: (data, { source }) => {
      const message =
        source === "onSubmit" ? "Template successfully updated." : "Successfully back to default.";
      SuccessNotification(message);
      queryClient.invalidateQueries({ queryKey: [ReactQueryKeys.TEMPLATE, `${data.code}`] });
    }
  });

  return {
    updateTemplateMutation
  };
}
